import { InjectionToken, signal } from '@angular/core';

export const DASHBOARDS_SUBTITLE = new InjectionToken('dashboard subtitle', {
  factory: () =>
    signal<{ key: string; params: Record<string, any> }>({
      key: '',
      params: {},
    }),
});